import PcMonitoring from 'quality/components/pcMonitoring/PcMonitoring'
import React, { useMemo } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'

const ResourcePcMonitoringApp = () => {
    const { id } = useParams()

    const {
        resource,
        associatedSites,
    } = useSelector(store => ({
        resource: store.ResourceReducer.resource,
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.resource,
        href: 'resource',
    }, {
        title: getStationTitle(resource),
        href: `station/resource/${id}`,
    }, {
        title: i18n.followUpPC,
        href: `station/resource/${id}/pcMonitoring`,
    }], [resource])

    const ids = useMemo(() => associatedSites.filter(site => site.stationLinkedType === 3).map(site => site.stationLinkedId), [associatedSites])

    return (
        <PcMonitoring
            ids={ids}
        />
    )
}

export default ResourcePcMonitoringApp